var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.deductiblePaymentOptions,"label":_vm.$t('transportationPermission.deductiblePayment.label', 'Excess payment method'),"disabled":_vm.disabled,"hint":_vm.hint,"persistent-hint":_vm.persistentHint,"value":_vm.selectedDeductiblePayment},on:{"input":_vm.selectDeductiblePayment}})
}
var staticRenderFns = []

export { render, staticRenderFns }